type TreeNodeProps = {
  id: string;
  expandId?: string;
  label: string;
  icon?: string;
  type?: string;
  totalVehicles?: number;
  children?: React.ReactNode;
  expanded: Set<string>;
  selected: string[];
  toggleExpand: (id: string) => void;
  toggleSelect: (id: string) => void;
  level?: number;
};

const TreeNode = ({
  id,
  expandId,
  label,
  children,
  icon,
  totalVehicles,
  type,
  expanded,
  selected,
  toggleExpand,
  toggleSelect,
  level = 0,
}: TreeNodeProps) => {
  const nodeExpandId = expandId ?? id;
  const isExpanded = expanded.has(nodeExpandId);
  const isSelected = selected.includes(id);

  return (
    <div>
      <div onClick={() => toggleExpand(nodeExpandId)} className="display-flex justify-content-between align-items-center gap-5 border border-color-lighter border-bottom-only margin-bottom-10 padding-bottom-10 padding-right-15 cursor-pointer" style={{ paddingLeft: level * 16 }}>
        <div className="display-flex align-items-center gap-5">
          <div className="form-group margin-0">
              <div className="display-flex align-items-center">
                <label className="checkbox margin-right-2">
                  <input
                    id="checkbox"
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggleSelect(id)}
                  />
                    <span className="checkbox-text"></span>
                </label>
                <div className="display-flex align-items-center gap-5 margin-left-5">
                  <p className="text-size-16 margin-0 text-color-gray">|</p>
                  <span className={`rioglyph padding-top-2 text-size-16 ${icon}`}></span>
                  <p className="margin-0 text-color-darkest text-size-14">
                    {label}
                  </p>
                </div>
              </div>
          </div>
        </div>

        {children && (
          <div className="display-flex align-items-center gap-10">
            {type === 'regional' ? (
              <div className="label label-default label-condensed">{totalVehicles}</div>
            ) : null}
            <span className={`rioglyph  ${isExpanded ? 'rioglyph-chevron-down' : 'rioglyph-chevron-up'}`}></span>
          </div>
        )}
      </div>

      {isExpanded && children}
    </div>
  );
};

export default TreeNode
